<template>
  <div class="home">

<section class="home-intro">
<picture>

<source media="(min-width: 768px)" :srcset="require('@/assets/Brees-home-bg-lg.jpg')">
<img :src="require('@/assets/Brees-home-bg-sm.jpg')" alt="Drew Brees Record and Stats Tracker">
</picture>

<header class="home-header">
<h1 class="">Drew Brees<small>Stats and Records over his Career</small></h1>
<p>Go through the long and successful career of New Orleans Saints quarterback Drew Brees. Track Brees' records, touchdown passes, and career stats vs all 32 NFL teams!</p>
</header>

<nav class="home-nav">
  <ul>
    <li><router-link to="/records"><img :src="require('@/assets/icon-records.png')" alt="Records Page">Records</router-link></li>
    <li><router-link to="/year"><img :src="require('@/assets/icon-years.png')" alt="Brees Over the Years">Over the Years</router-link></li>
    <li><router-link to="/charts"><img :src="require('@/assets/icon-charts.png')" alt="Stat Charts Page">Charts</router-link></li>
  </ul>
</nav>
      
</section>  
      




<!-- 
    <img class="home-promo-image" alt="Drew Brees Most Passing Yards in NFL History" :src="require('@/assets/' + topImage2)">
     <img class="home-promo-image" alt="Drew Brees Most Completions in NFL History" :src="require('@/assets/' + topImage4)">
    <img class="home-promo-image" alt="Drew Brees with 10 seasons of at least 30 touchdown passes" :src="require('@/assets/' + topImage6)"> -->

  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'home',
  components: {  },
  metaInfo: {
    meta: [
      { name: 'google-site-verification', content: '-ToZhB9USUaGAJhr2sY2jE-eaPp-d3KQbLdE2HVPI1A' }
    ],
    title: 'Drew Brees | Over the Years | A Compilation of Stats & Records | Record Tracker',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      topImage: "brees-homepage-hero-bit.gif",
      
      topImage0: "Drew-Brees-Record-King.gif",
   
      topImage1: "Drew-Brees-Most-Yards-Tds.gif",
      topImage2: "Brees-MostPassYds-Milestone-Selective.gif",
      topImage3: "Drew-Brees-Consecutive-Completions.gif",
      topImage4: "Drew-Brees-Most-Completions.gif",
      topImage5: "Drew2inTDs.gif",
      topImage6: "drew-30plus.gif",
  }
}
}
</script>

<style>

.home-promo-image {
  width:100%;
}

.home-top-image {
    height: 924px;
    background-size: contain;
    background-position: top center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.home-overlay {
  font-size:100px;
  font-weight: 700;
  font-family: 'Teko', sans-serif;
  color: #c3b280;
}

header.home-header {
      font-weight: 700;
    font-family: 'Teko', sans-serif;
    color:#fff;
    padding:15px;

    position: relative;
}
header.home-header h1 {
    text-transform: uppercase;
    font-size: 13vw;
    line-height: 13vw;
}
header.home-header h1>small {
    display:block;
    font-size: 4vw;
    line-height: 4vw;
}

header.home-header p {
    font-size: 5vw;
    line-height: 6vw;
    font-weight:normal;
}
nav.home-nav ul {

    position: relative;
    padding: 0px;
    list-style: none;
    max-width: 230px;
    margin: 0 auto;
}
nav.home-nav li  {
width:100%;
}
nav.home-nav li a {
  font-family: 'Teko', sans-serif;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 25px;
    line-height: 25px;
    margin-bottom: 15px;
    color: #dace9a;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 800;
    text-decoration: underline;
    text-decoration-color: white;
}
nav.home-nav li a img {
margin-right:15px;
}

section.home-intro {
    padding: 30px 0px;
    overflow:hidden;
    position:relative;
height: calc(100vh - 50px);
}

.home-intro picture {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height:100%;
    overflow:hidden;
}
.home-intro picture img {
    object-fit:contain;
    width:100%;
}

@media (max-width:1700px) {
  .home-top-image {
          height: 850px;
  }
}


@media (max-width:1366px) {
.home-top-image {
    height: 718px;
}
}

@media (max-width:1024px) {
.home-top-image {
    height: 600px;
}

}

@media (max-width:420px) {
.home-top-image {
    height: 430px;
    background-size: cover;
    background-position-x: -349px;
}
  .home-overlay {
  font-size:50px;

}
}


@media (max-width:375px) {
.home-top-image {
    height: 430px;
    background-size: cover;
    background-position-x: -349px;
}
}


@media (max-width:320px) {
.home-top-image {
    background-position-x: -389px;
}
}





@media (min-width:768px) {
  nav.home-nav ul {
    display: flex;
    max-width: 100%;
    justify-content: center;
    align-items: center;
}
nav.home-nav li a {
    justify-content: center;
    align-items: center;
    font-size: 40px;
    line-height: 40px;
}
header.home-header p {
    font-size: 33px;
    line-height: 44px;
}
header.home-header h1 {
    text-transform: uppercase;
    font-size: 130px;
    line-height: 130px;
}
header.home-header h1>small {
    display: block;
    font-size: 43px;
    line-height: 43px;
}
header.home-header {
    max-width: 1000px;
    margin: 0 auto;
}
.home-intro picture {
   
}
.home-intro picture img {
    -o-object-fit: contain;
    object-fit: cover;
    height: 100%;
    object-position: initial;
    position: relative;
   
}
}



</style>


// WEBPACK FOOTER //
// src/views/Home.vue